import { VChip } from 'vuetify/lib/components/VChip';
import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VExpandTransition,[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showExtraFields),expression:"showExtraFields"}],staticClass:"story-fields"},[_c('div',{staticClass:"column"},[_vm._l((_vm.fields),function(tag,index){return _c('div',{key:index,staticClass:"meta-chips"},[(tag.label)?_c(VChip,{staticClass:"meta-chip",attrs:{"label":""}},[_vm._v("\n            "+_vm._s(_vm.extraFieldContent(tag))+"\n          ")]):_vm._e()],1)})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }